import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { navigate } from "wouter/use-browser-location"
import { useStore } from "../../../contexts/store"
import Thread from "../../Elements/Thread"

import { Box, Button, IconButton } from "@mui/material"
import ArrowBackIcon from '@mui/icons-material/ArrowBackIos'

const ActiveConversation = ({podId, activeConversationId}: {podId: string, activeConversationId: string}) => {
  const { t } = useTranslation()
  const { uiStore, podStore } = useStore()
  const nodeId = podStore.getNodeId(activeConversationId)
  const [ isRendered, setIsRendered] = useState(false)

  useEffect(() => {
    setIsRendered(true)
  }, [])

  const pod = podStore.pod
  if (!pod) return null
  const interaction = (activeConversationId && nodeId) ? pod.getInteraction(activeConversationId) : null


  const ActiveConversationHeader = () => (
    <Box sx={{
      alignItems: "center",
      borderBottom: "1px solid rgba(63, 67, 80, 0.16)",
      color: "#3b3b3b",
      display: "grid",
      fontSize: "18px",
      gridTemplateColumns: "max-content auto",
      height: "61px",
      padding: "0 20px"
    }}>
      <IconButton size="small" aria-label="back" onClick={() => resetActiveConversationId()}>
        <ArrowBackIcon fontSize="small" sx={{color: "textcolor.light"}} />
      </IconButton>
      <Box sx={{justifySelf: "end"}}>
        <Button variant="outlined" size="small" onClick={() => navigateToInteraction(nodeId, "comment", activeConversationId)}>
          {t('Jump to the text passage')}
        </Button>
      </Box>
    </Box>
  )

  // show blank page until elements are rendered
  if(isRendered === false) return <ActiveConversationHeader />
  if(interaction === null) return <ActiveConversationHeader />

  const resetActiveConversationId = () => {
    const currentLocation = window.location.pathname
    uiStore.setActiveConversation(podId, null)
    const url = `/pod/${podId}/conversations`
    navigate(url, { replace: true, state: {prevUrl: currentLocation} })
  }

  const navigateToInteraction = (nodeId: string | null, interactionType: string, interactionId: string | null) => {
    if(nodeId && interactionType && interactionId) {
      const currentLocation = window.location.pathname
      const url = `/pod/${podId}/pdf/${nodeId}/${interactionType}/${interactionId}`
      navigate(url, { state: {prevUrl: currentLocation} })
    }
  }

  return(
    <Box sx={{display: "grid", gridTemplateRows: "max-content auto"}}>
      <ActiveConversationHeader />
      <Thread interaction={interaction} podId={podId} />
    </Box>
  )
}

export default observer(ActiveConversation)